import type { NotificationItemBasicInfoType } from './notificationItemBasicInfoType';

export type NotificationItemBasicInfo = {
  /** @nullable */
  content?: string | null;
  /** @nullable */
  createdAt?: string | null;
  id: number;
  type: NotificationItemBasicInfoType;
  /** @nullable */
  updatedAt?: string | null;
  userId: number;
};
